module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('transition', {
    attrs: {
      "name": "c-fade",
      "mode": "out-in"
    }
  }, [_c('div', {
    staticClass: "relative",
    staticStyle: {
      "background": "url('') center center no-repeat",
      "background-size": "contain",
      "padding-bottom": "calc(100%*800/1600)",
      "overflow": "hidden"
    }
  }, [_c('transition', {
    attrs: {
      "css": false
    },
    on: {
      "before-enter": _vm.beforeEnter,
      "enter": _vm.enter,
      "leave": _vm.leave
    }
  }, [(this.slidestate === 0) ? _c('div', {
    key: "s0",
    staticClass: "absolute"
  }, [_c('img', {
    staticStyle: {
      "width": "100vw"
    },
    attrs: {
      "src": require("./assets/sd_slide_i1.jpg")
    }
  })]) : _vm._e(), _vm._v(" "), (this.slidestate === 1) ? _c('div', {
    key: "s1",
    staticClass: "absolute"
  }, [_c('img', {
    staticStyle: {
      "width": "100vw"
    },
    attrs: {
      "src": require("./assets/sdcar4.jpg")
    }
  })]) : _vm._e(), _vm._v(" "), (this.slidestate === 2) ? _c('div', {
    key: "s2",
    staticClass: "absolute"
  }, [_c('img', {
    staticStyle: {
      "width": "100vw"
    },
    attrs: {
      "src": require("./assets/sdcar6.png")
    }
  })]) : _vm._e(), _vm._v(" "), (this.slidestate === 3) ? _c('div', {
    key: "s3",
    staticClass: "absolute"
  }, [_c('img', {
    staticStyle: {
      "width": "100vw"
    },
    attrs: {
      "src": require("./assets/sd_slide_i3.jpg")
    }
  })]) : _vm._e(), _vm._v(" "), (this.slidestate === 4) ? _c('div', {
    key: "s4",
    staticClass: "absolute"
  }, [_c('img', {
    staticStyle: {
      "width": "100vw"
    },
    attrs: {
      "src": require("./assets/sd_slide_i4.jpg")
    }
  })]) : _vm._e(), _vm._v(" "), (this.slidestate === 5) ? _c('div', {
    key: "s5",
    staticClass: "absolute"
  }, [_c('img', {
    staticStyle: {
      "width": "100vw"
    },
    attrs: {
      "src": require("./assets/sd_slide_i4.jpg")
    }
  })]) : _vm._e()])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-150810d1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 14
// module chunks = 0